<template>
	<div class="invoce-bg">
		<div class="bgImgHeader">
			<header class="lmy-header lmy-header-w">
				<i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
				佣金提现
			</header>
		</div>
		<div class="withdraw-content">
			<div class="top">
				<span class="left">本次可提现金额(元)</span>
				<span class="right" @click="routetokPage('/payment')" >账户流水</span>
			</div>
			<!-- >余额 -->
			<div class="price">{{Info.CanWithdrawedAmount|numberFloat}}</div>
			<!-- 累计提现 -->
			<!-- <div class="price">{{(Info.TotalWithdrawed)|numberFloat}}</div> -->
		</div>

	    <div class="lmy-withdraw" v-if="loading">
		    <div class="infinite-loading-containers" >
				<i class="loading-defaults"></i>
			</div>
		</div>
	    <div class="lmy-withdraw" v-if="!loading">
	        <div class="withdraw-rule">
	            <div class="title">提现条款</div>
	            <div class="rule-content">
									<p>1.由于微信转账到零钱额度限制，超过200元的需要分多次提现；</p>
	                <p>2.订单离店后返佣方可进入账户；</p>
	                <p>3.每晚23:00系统自动统计数据；</p>
	                <p>例如：您的返佣订单是09月04日至09月05日，那么该返佣将在09月05日 23:00以后更新至您的账户。</p>
									
	            </div>
				<div class="grayBtn withdrawBtn" @click="routeToWithdraw">立即提现</div>

	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'withdraw',
		data(){
			return{
				Info:'',
				iswdbShow:true,
				loading:true
			}
		},
		methods:{
			routeToWithdraw(){
				// this.error({title:'提示',content:'由于受微信交易条款限制，我们会在7月20日开启微信提现功能，在此之前因订单生成的佣金将会累积在您的佣金账户余额内，功能开启后方可提现，敬请理解。'})
				// return;
				if(!this.Info){
					this.$alert('账户余额不够，还不能提现哦！')
					return;
				}
				if(!this.Info.Token){
					this.$alert('间夜数不够1间，还不能提现哦！')
					return;
				}
				this.routetokPage('/withdrawAccount');
			},
			initData(){	
				
 		 		var that=this;
 		 		var param={
					Page:0,
					PageSize:10,
					WithdrawID:'',
				}
				that.postRequest({
					url:that.Api.getBills,
					params:param 
				}).then(res => {
					this.loading=false;
					if (res&&res.IsSuccess) {
				        that.Info =res.Result;
				        that.dao.set('UserWithdrawInfo',JSON.stringify(res.Result))
				    } 
				});
 		 	}
			
		},
		mounted(){
			this.initData();
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/usr/withdraw/withdraw.vue